import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { SWizardGridItemChild, SWizardGridItemShare } from './WizardGridItem.styled'
import { forwardRef, ReactNode } from 'react'
import { pxToRem } from 'utils/styled'

export const WizardGridItem = forwardRef<
  HTMLButtonElement,
  {
    ['data-testid']?: string
    className?: string
    image?: ReactNode
    share?: ReactNode
    children?: ReactNode
    active?: boolean
    onClick?: () => void
  }
>((props, ref) => {
  return (
    <Button
      type="button"
      variant="secondary"
      css={css`
        padding: 10px;
        min-height: ${pxToRem(60)}rem;
        height: unset;
        justify-content: flex-start;
        color: var(--c-gray100);

        & > span {
          width: 100%;
          display: flex;
          align-items: center;
        }
      `}
      data-testid={props['data-testid']}
      className={props.className}
      active={props.active}
      onClick={props.onClick}
      ref={ref}
    >
      {props.image}
      <SWizardGridItemChild>{props.children}</SWizardGridItemChild>

      {props.share && <SWizardGridItemShare>{props.share}</SWizardGridItemShare>}
    </Button>
  )
})

WizardGridItem.displayName = 'WizardGridItem'

export const WizardGridItemImage = styled.span`
  width: ${pxToRem(36)}rem;
  height: ${pxToRem(36)}rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
`

export const WizardGridItemLarge = forwardRef<
  HTMLButtonElement,
  {
    ['data-testid']?: string
    className?: string
    image?: ReactNode
    share?: ReactNode
    title?: ReactNode
    description?: ReactNode
    active?: boolean
    isReadOnly?: boolean
    onClick?: () => void
  }
>((props, ref) => {
  return (
    <Button
      type="button"
      variant="secondary"
      css={css`
        height: unset;
        padding: 10px;
        white-space: normal;
        color: var(--gray-100);

        & > span {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }
      `}
      data-testid={props['data-testid']}
      active={props.active}
      disabled={props.isReadOnly}
      onClick={props.onClick}
      ref={ref}
    >
      <span
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
        `}
      >
        {props.image}
        {props.share && <SWizardGridItemShare>{props.share}</SWizardGridItemShare>}
      </span>

      <span
        css={css`
          padding: 5px;
          text-align: left;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
        `}
      >
        <span
          css={css`
            flex-grow: 1;
            text-align: left;
            font-size: ${pxToRem(17)}rem;

            display: flex;
            margin-bottom: 3px;
          `}
        >
          {props.title}
        </span>
        <span
          css={css`
            font-size: ${pxToRem(13)}rem;
            color: var(--c-gray500);
            font-weight: 400;
            text-align: left;
          `}
        >
          {props.description}
        </span>
      </span>
    </Button>
  )
})
WizardGridItemLarge.displayName = 'WizardGridItemLarge'
